import { render } from "./TelegramEditor.vue?vue&type=template&id=a87efb40"
import script from "./TelegramEditor.vue?vue&type=script&lang=js"
export * from "./TelegramEditor.vue?vue&type=script&lang=js"

import "./TelegramEditor.vue?vue&type=style&index=0&id=a87efb40&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__